// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useRef, useState, useContext} from 'react';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import {use_theme} from '../settings_ctx';
import {use_element_size, use_screen} from '../lib/screen_util';
import {img_url} from '../ui/img_url';
import {Lottie} from '../lib/lottie';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './timeline_animation.module.less';

export const Timeline_animation = ()=>{
    const {theme} = use_theme();
    const anim = useRef();
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const animation = [
        {frames: {from: 0, to: 125}, direction: 1, loop: false},
    ];
    const [w, h] = use_element_size(is_client && {
        xs: [375, 108],
        sm: [375, 108],
        md: [600, 225],
        all: [800, 300],
    });
    const from = useRef(0);
    const [to, set_to] = useState(0);
    const {width} = use_screen();
    const events = [
        {
            frame: 0,
            text: `Hola says Hola! to the world and
                kickstarts its commitment to a Better Internet for All.`,
        },
        {
            frame: 25,
            text: `Building on the great response since launch, Hola expands
                its product range to include even more of your favorite
                devices!`,
        },
        {
            frame: 50,
            text: `Hola hits its stride with 100 million downloads, further
                enhancing the goal of bringing a Borderless Internet to life!`,
        },
        {
            frame: 75,
            text: `Pandemics...lockdowns... Hola launches apps for Smart TVs,
                which is pretty smart, considering!`,
        },
        {
            frame: 100,
            text: `Hola breaks its own record, getting to 200 million
                downloads. Our love for our users is now 200 million strong!`,
        },
        {
            frame: 125,
            text: `The Hola brand gets a fresh update, creating a more
                engaging and exciting look, with an enhanced user experience
                for all.`,
        },
    ];
    const lottie = width > 764 ? 'animation/about_timeline.json' :
        'animation/about_timeline_mobile.json';
    const on_prev = ()=>{ set_to(v=>v-25); };
    const on_next = ()=>{ set_to(v=>v+25); };
    useEffect(()=>{
        if (to==from.current || !anim.current)
            return;
        // @ts-ignore
        anim.current._lottie.playSegments([[from.current, to]], true);
        from.current = to;
    }, [to, anim.current]);
    return <div className={styles.timeline}>
      {events.map(({frame, text})=>{
          const event_cls = cn(styles.event, {
              [styles.before]: frame<to && styles.before,
              [styles.active]: frame==to && styles.active,
              [styles.after]: frame>to && styles.after,
          }, width <= 764 ? theme.p2 : null);
          return <p key={frame} className={event_cls}>
            {text}
          </p>;
      })}
      <Lottie src={img_url(lottie)} width={w} key={`${w}-${h}`}
        height={h} animation={animation} timeout={0} fixed_frame={0}
        on_create={l=>{ anim.current = l; }}/>
      <div className={styles.controls}>
        <button className={styles.prev} disabled={to==0}
          onClick={on_prev}>PREV</button>
        <button className={styles.next} disabled={to==125}
          onClick={on_next}>NEXT</button>
      </div>
    </div>;
};

interface i_timeline_animation_editor_props {
    value: never;
    on_change: (new_val: never)=>void;
}

export const Timeline_animation_editor = (
{value, on_change}: i_timeline_animation_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
